/** Différentes valeurs possibles pour le type de retour de l'action à exécuter. */
export enum EFilterActionReturnType {

	object,
	observable,
	promise,
	void,
	/** Dans ce cas, l'action n'est pas exécutée, on simule un clic sur le composant de filtrage directement. */
	undefined
}